import { useEffect, useState, type ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

interface AnimationWrapperProps {
  show: boolean;
}

const AnimationWrapper = styled.div<AnimationWrapperProps>`
  animation: ${(props) => (props.show ? fadeIn : fadeOut)} 1s;
  height: 100%;
  ${(props) =>
    !props.show &&
    `
    position: absolute;
    width: 100%;
  `}
`;

interface FadeProps {
  show: boolean;
  children: ReactNode;
}

const Fade = ({ show, children }: FadeProps) => {
  const [shouldRender, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };

  return (
    shouldRender && (
      <AnimationWrapper show={show} onAnimationEnd={onAnimationEnd}>
        {children}
      </AnimationWrapper>
    )
  );
};

export default Fade;
export type { FadeProps };
